<script>
    import { page } from "$app/stores";
    import ThemeToggle from "$lib/components/ThemeToggle.svelte";
    import SoundToggle from "$lib/components/SoundToggle.svelte";

    const isActive = (path) => {
        if (path === "/blog") {
            // Make blog link active for /blog and all /posts/* pages
            return (
                $page.url.pathname === path ||
                $page.url.pathname.startsWith("/posts/")
            );
        }
        return $page.url.pathname === path;
    };
</script>

<nav class="navbar navbar-expand-lg fixed-top global-nav">
    <div class="container">
        <a
            class="navbar-brand"
            class:active={isActive("/")}
            href="/"
            aria-label="dinglandia home"
            ><div class="icon-new" name="logo"></div></a
        >
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav">
                <li class="nav-item">
                    <a
                        class:active={isActive("/process")}
                        class="nav-link"
                        href="/process">Process</a
                    >
                </li>
                <li class="nav-item">
                    <a
                        class:active={isActive("/services")}
                        class="nav-link"
                        href="/services">Services</a
                    >
                </li>
                <li class="nav-item">
                    <a
                        class:active={isActive("/mission")}
                        class="nav-link"
                        href="/mission">Mission</a
                    >
                </li>
                <li class="nav-item">
                    <a
                        class:active={isActive("/work")}
                        class="nav-link"
                        href="/work">Work</a
                    >
                </li>
                <li class="nav-item">
                    <a
                        class:active={isActive("/blog")}
                        class="nav-link"
                        href="/blog">Blog</a
                    >
                </li>
                <li class="nav-item">
                    <a
                        class:active={isActive("/contact")}
                        class="nav-link"
                        href="/contact">Contact</a
                    >
                </li>
            </ul>
        </div>
        <div class="nav-controls">
            <div class="nav-toggle-stack">
                <ThemeToggle />
                <div class="sound-toggle-wrapper">
                    <SoundToggle />
                </div>
            </div>
            <button
                class="navbar-toggler menu-button"
                type="button"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
                data-menu-button="burger"
            >
                <span class="menu-button-line"></span>
                <span class="menu-button-line"></span>
                <span class="menu-button-line"></span>
            </button>
        </div>
    </div>
    <div class="clouds"></div>
</nav>
